export enum Name {
    V1database = 'v1-database',
    V1deletes = 'v1-deletes',
    V1audits = 'v1-audits',
    V1mails = 'v1-mails',
    V1functions = 'v1-functions',
    V1usage = 'v1-usage',
    V1usagedump = 'v1-usage-dump',
    Webhooksv1 = 'webhooksv1',
    V1certificates = 'v1-certificates',
    V1builds = 'v1-builds',
    V1messaging = 'v1-messaging',
    V1migrations = 'v1-migrations',
    Hamsterv1 = 'hamsterv1',
}